import { useStore } from "@/lib/store";
import { Link } from "react-router-dom";
import { t } from "@/lib/i18n";

export default function Account() {
  const { customerId } = useStore();
  return (
    <div className="pt-24 md:pt-32 px-5 md:px-12 pb-24 md:pb-32">
      <p className="text-eyebrow mb-3">{t.account.eyebrow}</p>
      <h1 className="font-serif-editorial text-5xl md:text-8xl mb-4">{t.account.title}</h1>
      <p className="text-[color:var(--marcini-fg-2)] max-w-xl mb-10 md:mb-12">{t.account.intro}</p>

      <div className="grid md:grid-cols-2 gap-6 md:gap-10 max-w-4xl">
        <div className="border border-[color:var(--marcini-border)] p-6 md:p-8">
          <p className="text-eyebrow mb-3">Logg inn</p>
          <p className="font-serif-editorial text-2xl mb-6">Tilgang til ordrehistorikk, favoritter og tidlige slipp.</p>
          <button data-testid="account-signin" className="border border-black w-full py-3 text-eyebrow hover:bg-black hover:text-white transition-colors">
            {t.account.signIn}
          </button>
          <p className="mt-4 text-xs text-[color:var(--marcini-fg-3)]">{t.account.signInHint}</p>
        </div>
        <div className="border border-[color:var(--marcini-border)] p-6 md:p-8">
          <p className="text-eyebrow mb-3">{t.account.session}</p>
          <dl className="text-sm space-y-3">
            <div className="flex justify-between gap-3"><dt className="text-[color:var(--marcini-fg-3)]">ID</dt><dd className="font-mono text-xs truncate max-w-[60%]" title={customerId}>{customerId}</dd></div>
            <div className="flex justify-between"><dt className="text-[color:var(--marcini-fg-3)]">{t.account.market}</dt><dd>{t.account.marketValue}</dd></div>
          </dl>
          <div className="mt-6 flex gap-4">
            <Link to="/wishlist" className="text-eyebrow link-underline">Ønskeliste →</Link>
            <Link to="/shop" className="text-eyebrow link-underline">Butikk →</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
